import { Getters } from 'vuex-smart-module';
import BlackListState from './state';

export default class BlackListGetters extends Getters<BlackListState> {}
